import FootballStats from "./FootballStats";
export default FootballStats;
